import { i18nTranslationHelper } from '@/i18n'
export namespace ContentSearchOrder {
  const t = {
    enuns: i18nTranslationHelper.getTEnums
  }
  export class Enum {
    static readonly RECOMMENDED = new Enum(
      1,
      'RECOMMENDED',
      t.enuns('contentSearchOrder.RECOMMENDED.label')
    )

    static readonly LONGER_DURATION = new Enum(
      2,
      'LONGER_DURATION',
      t.enuns('contentSearchOrder.LONGER_DURATION.label')
    )

    static readonly SHORTER_DURATION = new Enum(
      3,
      'SHORTER_DURATION',
      t.enuns('contentSearchOrder.SHORTER_DURATION.label')
    )

    private constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string
    ) {}
  }

  export const getByName = (name: string): Enum => {
    return Object.values(ContentSearchOrder.Enum).find(type => type.name === name)
  }

  export const getAll = (): Enum[] => {
    return Object.values(ContentSearchOrder.Enum)
  }
}
